import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

type Fact = "isPast" | "isFuture";

export const checkPastOrFutureDate = (fact: Fact, date: any): boolean => {
  if (fact === "isPast") {
    return dayjs(date).isValid() ? dayjs.utc(date).local() < dayjs().local() : false;
  } else if (fact === "isFuture") {
    return dayjs(date).isValid() ? dayjs.utc(date).local() > dayjs().local() : false;
  } else {
    return false;
  }
};
